import { render, staticRenderFns } from "./BuhinExtremeLink.vue?vue&type=template&id=98423040&"
import script from "./BuhinExtremeLink.vue?vue&type=script&lang=ts&"
export * from "./BuhinExtremeLink.vue?vue&type=script&lang=ts&"
import style0 from "./BuhinExtremeLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BuhinExtremeLink.vue"
export default component.exports